import Template from './root.component'

// To view the skeleton loader during development, uncomment this line and comment out the line above
// import Template from './root.loader'

export default Template
